import { Action, combineReducers } from '@ngrx/store';

import { State } from '../models';

import {
  businessConfigStripReducer,
  businessInitialState,
} from './config-strip-business.reducer';
import {
  dataConfigStripReducer,
  dataInitialState,
} from './config-strip-data.reducer';
import {
  uiConfigStripReducer,
  uiInitialState,
} from './config-strip-ui.reducer';

export const initialState = {
  ui: uiInitialState,
  business: businessInitialState,
  data: dataInitialState,
};

/**
 * The real reducer. Needed because of angular AOT
 */
export function reducer(state: State | undefined, action: Action) {
  return combineReducers({
    ui: uiConfigStripReducer,
    business: businessConfigStripReducer,
    data: dataConfigStripReducer,
  })(state, action);
}
